import type { MailFolder } from 'owa-graph-schema';
import getMailboxFolderTreeDataTable from './getMailboxFolderTreeDataTable';
import type { MailboxInfo } from 'owa-client-types';

/**
 * Selector for a particular mailbox folder tree root folder
 * @param folderTreeIdentifier identifies the tree uniquely (primary \archive \ shared)
 * @param userIdentity identifies the mailbox uniquely
 */
export default function getRootFolderForFolderTree(
    folderTreeIdentifier: string,
    mailboxInfo: MailboxInfo
): MailFolder | undefined {
    const mailboxFolderTreeDataTable = getMailboxFolderTreeDataTable(mailboxInfo);
    const folderTreeData =
        mailboxFolderTreeDataTable && mailboxFolderTreeDataTable.get(folderTreeIdentifier);
    return folderTreeData?.rootFolder;
}
